<template>
  <svg :viewBox="icon.viewBox" :width="width" :height="height" :class="iconClass">
    <use :xlink:href="`#${icon.id}`"></use>
  </svg>
</template>

<script>
  export default {
    props: ['width', 'height', 'icon'],
    computed: {
      iconClass () {
        if (!this.icon) return ''
        return `icon--${this.icon.id}`
      }
    }
  }
</script>

<style lang="scss">
  .icon {
    &--dollar-sign {
      width: rem(11px) !important;
      height: rem(21px) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// SvgIcon.vue?0d9e6b94